module.exports = __webpack_public_path__ + "img/saida.846d19eb.svg";